// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__nH_FT","title":"Footer_title__ZStl1","footerNav":"Footer_footerNav__hpvjx","footerLinks":"Footer_footerLinks__a5eVd"};